module.exports = __webpack_public_path__ + "assets/img/00016.bcbbe2bb.png";